import BaseCard from "../../../components/ui/BaseCard";
// Parked until the Assessment feature ships — the step is still routable so the
// stepper keeps its shape, but it shows a placeholder instead of the forms.
// import ShipmentsForm from "../Forms/ShipmentsForm";
// import ProviderAssessmentForm from "../Forms/ProviderAssessmentForm";
// import SelectionRulesForm from "../Forms/SelectionRulesForm";
// import SmartAuditForm from "../Forms/SmartAuditForm";

const Assessment = () => {
  return (
    <div>
      <BaseCard className="py-2 sm:py-4 lg:px-16 px-5 mt-1 rounded-lg" elevation={1}>
        {/* Matches the section headers on the other steps, so the step doesn't
            read as a broken page while the forms are parked. */}
        <div className="border-bottom mb-2 sm:mb-4">
          <h6 className="mb-1 sm:mb-2 text-dark">
            Assessment <span className="font-light italic text-base">– Coming Soon</span>
          </h6>
        </div>
        <div className="flex items-center py-6">
          <i className="fa-solid fa-hourglass-half text-primary mr-3" />
          <p className="font-light">Shipments, Provider Assessment, Selection Rules, Smart Audit</p>
        </div>
      </BaseCard>

      {/* <ShipmentsForm />
      <ProviderAssessmentForm />
      <SelectionRulesForm />
      <SmartAuditForm /> */}
    </div>
  );
};

export default Assessment;
